"use client";
import { FilloutStandardEmbed } from '@fillout/react';
import { useAuthStore } from '@/lib/auth-store';
import React from 'react';

export default function Features() {
    const { user } = useAuthStore();
    return (
        <section className="py-10 bg-gray-50 sm:py-16 lg:py-24" id="cta">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="max-w-xl mx-auto text-center">
                    
                    <h2 className="mt-6 text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl">Built, Branded, and Maintained</h2>
                </div>

                <div className="grid items-start grid-cols-1 mt-12 gap-y-10 lg:grid-cols-5 sm:mt-20 gap-x-4">
                    <div className="space-y-8 lg:pr-16 xl:pr-24 lg:col-span-2 lg:space-y-12">
                        <div className="flex items-start">
                            <svg className="flex-shrink-0 text-blue-500 w-9 h-9" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                            <div className="ml-5">
                                <h3 className="text-xl font-semibold text-black">Done-for-You Dashboards</h3>
                                <p className="mt-3 text-base text-gray-600">We build your Looker Studio reports for you - fully set up, styled with your branding, and connected to your sources. No setup work on your end.</p>
                            </div>
                        </div>

                        <div className="flex items-start">
                            <svg className="flex-shrink-0 text-blue-500 w-9 h-9" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                            <div className="ml-5">
                                <h3 className="text-xl font-semibold text-black">All Premium Connectors Included</h3>
                                <p className="mt-3 text-base text-gray-600">Meta Ads, LinkedIn Ads, Shopify, Bing, TikTok, and more - all included at the same $25 per source.</p>
                            </div>
                        </div>


                        <div className="flex items-start">
                            <svg className="flex-shrink-0 text-blue-500 w-9 h-9" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                            <div className="ml-5">
                                <h3 className="text-xl font-semibold text-black">Custom Branding</h3>
                                <p className="mt-3 text-base text-gray-600">We add your website or agency logo to every dashboard for a professional, branded presentation.</p>
                            </div>
                        </div>

                    

                        <div className="flex items-start">
                            <svg className="flex-shrink-0 text-blue-500 w-9 h-9" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                            <div className="ml-5">
                                <h3 className="text-xl font-semibold text-black">Tracking Setup (Add-On)</h3>
                                <p className="mt-3 text-base text-gray-600">Need help setting up GA4, Meta Pixel, or Shopify events? We offer complete tracking setup as a one-time service if needed.</p>
                            </div>
                        </div>

                        <div className="flex items-start">
                            <svg className="flex-shrink-0 text-blue-500 w-9 h-9" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                            <div className="ml-5">
                                <h3 className="text-xl font-semibold text-black">Unlimited Revisions</h3>
                                <p className="mt-3 text-base text-gray-600">You don't edit the dashboards directly. Just tell us what you need - we'll update it and keep things tidy.</p>
                            </div>
                        </div>

                        <div className="flex items-start">
                            <svg className="flex-shrink-0 text-blue-500 w-9 h-9" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                            <div className="ml-5">
                                <h3 className="text-xl font-semibold text-black">Ongoing Support</h3>
                                <p className="mt-3 text-base text-gray-600">We monitor your connectors, refreshes, and data health. If something breaks, we fix it. Just reach out.</p>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-3">
                        <FilloutStandardEmbed
                            filloutId="mA6ky2xCHhus"
                            dynamicResize={true}
                            inheritParameters={true}
                            parameters={{
                                email: user?.email || '',
                                name: user?.name || ''
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}




